import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { useParams } from 'react-router-dom';
import { Tabs } from "@mui/material";
import { TabLink } from 'components';

const a11yProps = (index) => {
  return {
    id: `tabpanel-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
};

const CascadeTabs = forwardRef((props, ref) => {
  const { tabs } = props;
  const { tabId: activeTab } = useParams();

  return (
    <>
      <Tabs
        ref={ref}
        value={activeTab}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="on"
      >
        {tabs.map((tab, idx) => (
          <TabLink
            key={tab.value}
            value={tab.value}
            label={tab.label}
            urlUpdateType="replace"
            to={tab.value}
            replace
            {...a11yProps(idx)}
          />
        ))}
      </Tabs>
    </>
  );
});

CascadeTabs.propTypes = {
  tabs: Type.arrayOf(
    Type.shape({
      label: Type.string.isRequired,
      value: Type.string.isRequired,
    }),
  ).isRequired,
};

export default CascadeTabs;
